<template lang="pug">
  div
    h1 Meet our <span>hard working</span> agents!
    div(class='agent-container' :class="{admin}")
      p(class='error' v-if='error') {{error}}
      AgentInfo(v-for='agent in agents' :agent='agent' :key='agent._id' @click.native='edit(agent)')
      el-button(v-if='admin' @click='clear(); editorVisible = true' class='add-agent' type='warning') Add Agent
      el-dialog(v-if='admin' :visible.sync='editorVisible')
        div(class='agent-editor')
          img(class='uploading-image' :src='uploadSrc' v-if='uploadSrc')
          span Upload a new photo 
          input(type="file" @change="imageSelected" name="image" id="image" accept="image/gif,image/jpeg,image/jpg,image/png" ref='fileUpload')
          el-form
            el-form-item( label="Name")
              el-input( v-model='agent.name' clearable)
            el-form-item( label="Email Address")
              el-input( v-model='agent.email' clearable)
            el-form-item( label="Phone")
              el-input( v-model='agent.phone' clearable)
            el-form-item( label="Bio")
              el-input( v-model='agent.bio' type='textarea' rows='4' clearable maxlength='350' show-word-limit)
            el-button( type="primary" @click='saveAgent') {{ agent._id ? "Save Changes" : "Add New Agent"}}
            el-button( @click='clear') Clear
            el-button( type="warning" @click='removeAgent' v-if='agent._id') Remove Agent
</template>

<script>
import AgentInfo from './AgentInfo.vue'
import {AGENTS_URL} from './settings.js'
import {mapState} from 'vuex'
const axios = require('axios');
axios.defaults.withCredentials = true;

export default {
  components: {
    AgentInfo
  },
  metaInfo: {
    title: 'Agents, Who We Are And How To Contact Us | Upright Realty',
    meta: [
      { name: 'description', content: 'The finest experienced Boston real estate agents at your service.  Contact us today for expert real estate service!' }
    ]
  },
  props: {
    loadedAgents: Array
  },
  data(){
    return{
      //JSON parse to deep clone array and prevent changes from affecting parent component's array
      agents: this.loadedAgents ? JSON.parse(JSON.stringify(this.loadedAgents)) : [],
      agent: {},
      image: null,
      uploadSrc: null,
      error: null,
      editorVisible: false
    }
  },
  computed: {
    ...mapState(['admin'])
  },
  methods:{
    
    async loadAgents(){
      try{ 
        const data = (await axios.get(AGENTS_URL)).data;
        this.agents = this.shuffle(data);
      }
      catch(e){ this.handleError(e, "Unable to track down our busy agents. Please try again later!") }
    },

    async addAgent(agent){
      try{
        const formData = new FormData();
        formData.append('newImage',this.image);
        const options = {
          params: {...agent},
          config: { headers: {'Content-Type': 'multipart/form-data' }}
        }
        const newAgent = (await axios.post(AGENTS_URL, formData, options)).data;

        const index = this.agents.findIndex(a => a._id == agent._id);
        if (index !== -1) { this.agents.splice(index, 1) }
        this.agents.push(newAgent);

        !this.agents.includes(agent)
          ? this.$notify.success({ title:this.address, message: `${agent.name} added to agents list.`, position:"bottom-right", offset: 100})
          :this.$notify.success({ title:this.address, message: `Changes to ${agent.name} saved successfully.`, position:"bottom-right", offset: 100});
        
        this.clear();
        this.editorVisible = false;
      }
      catch(e){ this.handleError(e, "Problem while attempting to add a new agent.") }
    },

    async deleteAgent(agent){
      try{
        if (!agent._id) return;
        await axios.delete(AGENTS_URL, {params: {id: agent._id}});
        const index = this.agents.findIndex(a => a._id == agent._id);
        if (index !== -1) { this.agents.splice(index, 1) }
        this.clear();
        this.editorVisible = false;
        this.$notify.success({ title:this.address, message: `${agent.name || "Agent"} removed.`, position:"bottom-right", offset: 100})
      }
      catch(e){ this.handleError(e, "Problem while attempting to remove an agent.") }
    },

    handleError(e, messageForUser){
      this.error = messageForUser;
      //console.error(e);
    },

    edit(agent){
      if (!this.admin) return;
      this.agent = agent;
      this.uploadSrc = agent.photo;
      this.editorVisible = true;
    },

    imageSelected(){
      this.image = this.$refs.fileUpload.files[0]
      
      var reader = new FileReader();
      reader.onload = () => {
        this.uploadSrc = reader.result;
      };
      reader.readAsDataURL(this.image);
    },

    clear(){
      this.agent = {};
      this.image = null;
      if (this.$refs.fileUpload) this.$refs.fileUpload.value = null;
      this.uploadSrc = null;
    },

    say(){ alert("BOOM" )},
    saveAgent(){ this.addAgent(this.agent) },
    removeAgent(){ this.deleteAgent(this.agent) },

    shuffle(a) {
      var j, x, i;
      for (i = a.length - 1; i > 0; i--) {
          j = Math.floor(Math.random() * (i + 1));
          x = a[i];
          a[i] = a[j];
          a[j] = x;
      }
      return a;
    }
  },
  async mounted(){
    //If no agents passed in, go get them
    if (!this.loadedAgents) this.loadAgents();
  }  
}
</script>

<style lang="scss" scoped>

.agent-container{
  display: flex;
  flex-wrap: wrap;
  min-height: 200px;
}

.admin.agent-container{
  cursor: pointer;
}

.uploading-image{
  width: 300px;
  height: 300px;
  object-fit: cover;
  display: block;
  margin: auto;
  margin-bottom: 20px;
}

#image{
  font-size: 1.3em;
}

.add-agent{
  width: 100%;
  margin: 30px;
  max-height: 50px;
}

h1{
  padding: 30px 10px;
  color: white;
  background-image: radial-gradient(circle, #303e6a, #181f35);
  font-weight: 100;
  margin: 20px 30px;
}

h1 > span{
  color: $color-accent;
  font-size: 1.2em;
  font-style: oblique;
}
</style>